import moment from 'moment-timezone';

export class PricingCopilotCustomOverviewMonthlyPerformanceChart {
	public minX: string;
	public dataPoints: {
		date: Date;
		data: number;
		hideTooltip: boolean;
	}[] = [];

	constructor(pricingCopilotCustomOverviewMonthlyPerformanceChart: PricingCopilotCustomOverviewMonthlyPerformanceChart) {
		Object.assign(this, pricingCopilotCustomOverviewMonthlyPerformanceChart);

		if (this.dataPoints) {
			this.dataPoints.forEach(d => new Date(moment(d.date).format('MMM DD, YYYY 00:00:00 a')));
		}
	}
}
